/**
 * Queensland Country Health Fund
 * Main website script runner.
 * @author Rhys Lloyd
 */

//
// Dependencies
import * as registry from '@core/registry';
import {HF_APP_MODULE} from '@core/registry/names';

//
// Local Dependencies
// log('Load dependencies...');
/* Favicons entry point for webpack
 * html_code.html as expected output from realfavicongenerator.net
 * manually insert `WEBPACKHACK` to content attribute of meta[name="msapplication-config"] i.e.
 * <meta name="msapplication-config" WEBPACKHACKcontent="./browserconfig.xml">
 */
require('./favicons/html_code.html');
//
// Dynamic Module Loaders
import dynamicLoadDatePicker from './modules/datepicker/dynamic-load';

// TODO: is this dynamic load redundant? Linked directly in cshtml? Or is that only CSS
import dynamicLoadCoverSelector from '@core/modules/cover-selector/dynamic-load';

import dynamicLoadLocator from './modules/locator/dynamic-load';
import dynamicLoadProductSelector from './modules/product-selector/dynamic-load';

//
// Constants
import debug from "debug";
const MODULE_NAME = HF_APP_MODULE;
const log = debug(MODULE_NAME);
//
// Register
if (!registry.exists(MODULE_NAME)) {
	registry.register(MODULE_NAME, registry.STATE.LOADING);
}

/**
 * Loads dynamic modules (polyfills etc.)
 */
export function loadDynamicModules () {
	//
	// Dynamic Modules
	log('Load dynamic modules...');

	dynamicLoadCoverSelector();
	dynamicLoadLocator();
	dynamicLoadDatePicker();
	dynamicLoadProductSelector();

	log('...dynamic modules done.');
}

//
// Application
/**
 * Execute Core Application
 */
export function exec () {
	log('Running...');

	// $(document).ready(() => {
	// 	log('Running document ready tasks...');
	// 	time('[hf-main.app] ...document ready tasks done.');
	//
	// 	timeEnd('[hf-main.app] ...document ready tasks done.');
	// });

}

export {exec as default};
registry.setState(MODULE_NAME, registry.STATE.LOADED);

//
// Conditionally Self Execute
if (!registry.isRegistered(MODULE_NAME)) {
	exec();
	loadDynamicModules();
	registry.setState(MODULE_NAME, registry.STATE.REGISTERED);
}



// WEBPACK FOOTER //
// ./project/client/src/site__hf/hf-main.app.js